export const atencion = [
    {
        "value": "Consulta",
        "codigo": 1
    },
    {
        "value": "Imagenología",
        "codigo": 2
    },  
    // {
    //   "value": "Procedimiento",
    //   "codigo": 3
    // }
];